export default {
  baseUrl: 'https://api.stg.digifab.stylem.co.jp',
  downloadUrl: 'https://download.stg.digifab.stylem.co.jp',
  algolia: {
    applicationId: 'HHG6K9OIKF',
    apiKey: 'cd09d7b550ba1c6a782db698ccb9fdc8',
    indexName: 'stg_fabric'
  }
}
